export default "__VITE_ASSET__61334212__"